// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wa16","select":"styles_select__1_r28"};